export default class AppCSSService {
    public static cardsWrapper = "py-4 sm:py-10 flex flex-col justify-center w-4/5 mt-4"

    public static textHeader = "text-md uppercase";
    public static textBig = "text-lg uppercase";
    public static textDefault = "text-lg";
    public static textSmall = "text-sm";

    public static onItemHover ="hover:scale-[1.05] duration-500"
    public static onItemHover1 ="hover:scale-[1.02] duration-500 hover:bg-gray-200 hover:bg-opacity-10";
}